module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dummy.png
// module id = rgtT
// module chunks = 1